import { render } from "./Academia.vue?vue&type=template&id=7c3ec9e0&scoped=true"
import script from "./Academia.vue?vue&type=script&lang=js"
export * from "./Academia.vue?vue&type=script&lang=js"

import "./Academia.vue?vue&type=style&index=0&id=7c3ec9e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c3ec9e0"]])

export default __exports__